// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ftsk0","btnGreen100":"Button_btnGreen100__yjOBF","btnGreen10":"Button_btnGreen10__VY4eI","btnWhite":"Button_btnWhite__vVys5"};